<app-breadcrumb [master]="'Rejestracje'" [parentName]="'Rejestracje'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Dane">
    <app-registration-details-view *ngIf="!modify"
                                   (changed)="loadRegistration()"
                                   (modifyClicked)="modify = true" [registration]="registration"></app-registration-details-view>
    <app-registration-details-form *ngIf="modify" [registrationObject]="registrationObject"
                                   (closeModification)="modify = false; loadRegistration()"></app-registration-details-form>
  </mat-tab>
  <mat-tab label="Identyfikatory">
    <app-registration-identifiers
      (changed)="loadRegistration()"
      [registration]=registration
                                   ></app-registration-identifiers>
  </mat-tab>
  <mat-tab label="Profile sprzedażowe">
    <ng-template matTabContent>
      <app-all-sales-profiles-list
        [reloadList]="reloadProfileListSubject" [disableBreadcrumb]="true" [disableFilters]="true"
        [registration]="registrationId"
        [embeddedView]="true"
      ></app-all-sales-profiles-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Dokumenty">
    <ng-template matTabContent>
      <button [disabled]="!(userPermissions | async).document.write" mat-stroked-button color="primary"
              class="add-button" (click)="addDocument()">
        <mat-icon>add</mat-icon>
        Dodaj dokument
      </button>

      <app-document-list [excludeColumns]="['deviceProtocolDate']" [documents]="documents"
                         (changed)="onDocumentAdded()"></app-document-list>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [registration]="registration"></app-log-list>
    </ng-template>
  </mat-tab>
</mat-tab-group>
